/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Sync_LockedInputs */

const bn_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তালাবদ্ধ`)
};

const de_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GESPERRT`)
};

const el_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΚΛΕΙΔΩΜΕΝΟ`)
};

const en_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LOCKED`)
};

const es_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BLOQUEADO`)
};

const fr_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VERROUILLÉ`)
};

const hi_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद`)
};

const hu_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BEZÁRT`)
};

const id_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TERKUNCI`)
};

const it_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BLOCCATO`)
};

const ja_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロックされています`)
};

const ko_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠김`)
};

const nl_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GESLOTEN`)
};

const pl_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZAMKNIĘTY`)
};

const pt_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BLOQUEADO`)
};

const ru_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗАБЛОКИРОВАНО`)
};

const sv_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LÅST`)
};

const tr_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KİLİTLİ`)
};

const uk_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗАБЛОКУВАНО`)
};

const vi_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐÃ KHÓA`)
};

const zh_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定`)
};

const zh_hant_cipher_system_sync_locked = /** @type {(inputs: Cipher_System_Sync_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鎖定`)
};

/**
* | output |
* | --- |
* | "LOCKED" |
*
* @param {Cipher_System_Sync_LockedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_sync_locked = /** @type {((inputs?: Cipher_System_Sync_LockedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Sync_LockedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_sync_locked(inputs)
	if (locale === "de") return de_cipher_system_sync_locked(inputs)
	if (locale === "el") return el_cipher_system_sync_locked(inputs)
	if (locale === "en") return en_cipher_system_sync_locked(inputs)
	if (locale === "es") return es_cipher_system_sync_locked(inputs)
	if (locale === "fr") return fr_cipher_system_sync_locked(inputs)
	if (locale === "hi") return hi_cipher_system_sync_locked(inputs)
	if (locale === "hu") return hu_cipher_system_sync_locked(inputs)
	if (locale === "id") return id_cipher_system_sync_locked(inputs)
	if (locale === "it") return it_cipher_system_sync_locked(inputs)
	if (locale === "ja") return ja_cipher_system_sync_locked(inputs)
	if (locale === "ko") return ko_cipher_system_sync_locked(inputs)
	if (locale === "nl") return nl_cipher_system_sync_locked(inputs)
	if (locale === "pl") return pl_cipher_system_sync_locked(inputs)
	if (locale === "pt") return pt_cipher_system_sync_locked(inputs)
	if (locale === "ru") return ru_cipher_system_sync_locked(inputs)
	if (locale === "sv") return sv_cipher_system_sync_locked(inputs)
	if (locale === "tr") return tr_cipher_system_sync_locked(inputs)
	if (locale === "uk") return uk_cipher_system_sync_locked(inputs)
	if (locale === "vi") return vi_cipher_system_sync_locked(inputs)
	if (locale === "zh") return zh_cipher_system_sync_locked(inputs)
	return zh_hant_cipher_system_sync_locked(inputs)
});